import { render, staticRenderFns } from "./RelatedTickets.vue?vue&type=template&id=01c467b1&scoped=true&"
import script from "./RelatedTickets.vue?vue&type=script&lang=ts&"
export * from "./RelatedTickets.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedTickets.vue?vue&type=style&index=0&id=01c467b1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c467b1",
  null
  
)

export default component.exports